import { client } from "@/client";
import {
  chipLookup,
  lookupChipFormatter,
} from "@/components/custom/data-table/filter-chip-lookups";
import { listPermissions } from "@/lib/list-permissions";

// The one set of options every device-tag list loads with: the devices TagsFilter, the images and
// sessions DeviceTagsFilter, the device overview, the bulk tag editor and the filter chip below.
// Sharing the object is what keeps them on one cache entry, refreshed by the invalidations that tag
// edits trigger on `client.devices.listTags.queryKey`.
export const deviceTagsQuery = client.devices.listTags
  .assign({
    page: 1,
    limit: 9999,
  })
  .asQueryOptions({});

/**
 * `filterBreadcrumbs` formatter for a device-tag filter key: `tagIds` on the device tables,
 * `devicesTagIds` on images and sessions.
 */
export const formatDeviceTagIdsChip = lookupChipFormatter(
  chipLookup({
    query: deviceTagsQuery,
    rows: (data) => data.results,
    permission: listPermissions.deviceTags,
  }),
);
